import { useMutation, useQuery } from '@tanstack/react-query';
import {
  fetchPhasedConstruction,
  savePhasedConstruction,
} from 'app/edozvola/cases/phased-construction/service/phased-construction.service';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { PhasedConstructionModel } from 'app/edozvola/cases/phased-construction/model/phased-construction.model';
import { toast } from 'react-toastify';
import success = toast.success;
import error = toast.error;
import {messages} from "app/config/constants";

export const fetchPhasedConstructionQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['phased-construction'],
    queryFn: () => fetchPhasedConstruction(idCase),
  });
};

export const savePhasedConstructionQuery = (idCase: string, onSuccessCallback) => {
  return useMutation({
    mutationFn: (phasedConstructionTypeModel: PhasedConstructionModel) => {
      return savePhasedConstruction(idCase, phasedConstructionTypeModel);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['phased-construction'] });
      onSuccessCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
